import React from 'react';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import FontIcon from 'material-ui/FontIcon';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/navigation/expand-more';
import MenuItem from 'material-ui/MenuItem';
import DropDownMenu from 'material-ui/DropDownMenu';
import RaisedButton from 'material-ui/RaisedButton';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import InstitutionSelector from './InstitutionSelector';

export default class Menu extends React.Component {

  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);    
  }    
  handleLogout(e){
    this.props.handleLogout(e);
    e.preventDefault();
  }
  
  render() {
    var toolbarStyle = {                              
          backgroundColor: '#007DA3',
        }    
    return (
      <Toolbar style={toolbarStyle}>
        <ToolbarGroup firstChild={true}>
          <img style={{"marginLeft":"15px",width: "200px"}} src="https://uspdigital.usp.br/alumni/images/logo_alumni.png"/>
        </ToolbarGroup>          
        <ToolbarGroup>  
             <InstitutionSelector/>
            <MenuItem style={{color:"#FFFFFF"}} onClick={this.handleLogout} primaryText="Sair" />                      
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

// import React, { PropTypes } from 'react';
// import '../style/Menu.css'
// import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, NavLink } from 'reactstrap';


// class Menu extends React.Component {

//   constructor(props) {
//     super(props);    
//     this.state = { expanded: false };

//     this.handleSelected = this.handleSelected.bind(this);
//     this.handleToggle = this.handleToggle.bind(this);
//     this.handleOpenAddChannelForm = this.handleOpenAddChannelForm.bind(this);
//     this.handleLogout = this.handleLogout.bind(this);
//   }

//   handleToggle() {
//     this.setState({ expanded: !this.state.expanded });
//   }

//   handleSelected() {
//     this.setState({ expanded: false });
//   }

//   handleOpenAddChannelForm(event) {
//     this.props.onOpenAddChannelForm(event);
//     this.handleSelected();
//   }

//   handleLogout(e){
//     this.props.handleLogout(e);
//     e.preventDefault();
//   }
//   render() {      
//     return (      
//       <div>
//         <Navbar className="alumni-nav navbar navbar-light navbar-fixed-top"  toggleable>
//           {/*<NavbarToggler right onClick={this.toggle} />*/}
//           <NavbarBrand className="alumni-brand navbar-brand" href="http://alumni.usp.br" target="_blank">            
//               <img src="https://uspdigital.usp.br/alumni/images/logo_alumni.png"/>            
//           </NavbarBrand>
//           {/*<Collapse isOpen={this.state.isOpen} navbar>*/}
//             <Nav className="ml-auto" navbar>
//               <NavItem>
//                 <NavLink style={{color:"white"}} href="#" onClick={this.handleLogout}>Sair</NavLink>
//               </NavItem>              
//             </Nav>
//           {/*</Collapse>*/}
//         </Navbar>
//       </div>
//     );
//   }
// }

// export default Menu;

// // <nav className="alumni-nav navbar navbar-light navbar-fixed-top">
//       //       <div className="alumni-brand navbar-brand">
//       //           <a className="nav-link" href="http://alumni.usp.br" target="_blank">
//       //             <img src="https://uspdigital.usp.br/alumni/images/logo_alumni.png"/>
//       //           </a>
//       //       </div>  
//       //       <Nav>
//       //       <button className="alumni-menu-button navbar-toggler " type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation"><i className="fa fa-bars" aria-hidden="true"></i> Menu</button>            
//       //       <div className="collapse navbar-toggleable-xs" id="navbarResponsive">
//       //           <div className="col-xs-12 col-md-8 col-xl-9">
//       //               <ul className="nav navbar-nav">
//       //                       <li className="nav-item dropdown">
//       //                           <a className="alumni-menu-item nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">Meus Dados</a>
//       //                           <div className="dropdown-menu">
//       //                               <a className="dropdown-item" href="javascript:sendMenu(9,'MYDATA');">Pessoais</a>
//       //                               <a className="dropdown-item" href="javascript:sendMenu(9,'PROFESSIONAL');">Profissionais</a>
//       //                               <div className="dropdown-divider"></div>
//       //                               <a className="dropdown-item" href="javascript:sendMenu(9,'SHOWLINKEDIN');">Linkedin</a>
//       //                               <a className="dropdown-item" href="javascript:sendMenu(9,'SHOWLATTES');">Lattes</a>
//       //                               <div className="dropdown-divider"></div>                                
//       //                               <a className="dropdown-item" href="javascript:sendMenu(9,'PASSWORD');">Trocar Senha&nbsp;</a>                                
//       //                                   <div className="dropdown-divider"></div>
//       //                                   <a className="dropdown-item" href="javascript:sendMenu(9,'MYPRIVACY');"><i className="fa fa-unlock-alt" aria-hidden="true"></i><font>&nbsp;&nbsp;</font>Privacidade</a>
//       //                                       <div className="dropdown-divider"></div>
//       //                                       <a className="dropdown-item" href="javascript:sendIDMember('6d8a34ee1a35ca46d0d4075a30757e45',55);"><i className="fa fa-user" aria-hidden="true"></i> &nbsp;Meu perfil</a>
//       //                           </div>
//       //                       </li>                                      
//       //                       <li className="alumni-menu-servico nav-item">
//       //                           <a className="alumni-menu-item">Serviços</a>
//       //                       </li>                        
//       //                       <div className="alumni-search input-group input-group-xs col-xs-12 col-md-5 col-xl-5">
//       //                           <input type="text" className="form-control" placeholder="buscar alumni" name="searchbox_input" id="searchbox_input" value=""/>
//       //                           <span className="input-group-btn">
//       //                               <button className="alumni-search btn btn-secondary" type="button">Buscar</button>
//       //                           </span>
//       //                       </div>
//       //                   <li className="nav-item dropdown">
//       //                       <a className="nav-link dropdown-toggle" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false"><i className="fa fa-wrench" aria-hidden="true"></i>&nbsp;</a>
//       //                       <div className="dropdown-menu">
//       //                                                               <a className="alumni-menu-item dropdown-item" href="javascript:sendForm(3);">Política Privacidade</a>                                
//       //                               <div className="dropdown-divider"></div>                                
//       //                               <a className="dropdown-item" href="javascript:sendForm(4);">Termos de Uso</a>                                
//       //                               <div className="dropdown-divider"></div>
                                
//       //                           <a className="dropdown-item" href="javascript:sendForm(2);"><i className="fa fa-bullhorn" aria-hidden="true"></i> &nbsp;Fale Conosco</a>
//       //                       </div>
//       //                   </li>
//       //                       <li className="alumni-exit nav-item">
//       //                           <a href="javascript:sendForm(8);">Sair</a>
//       //                       </li>                        
//       //               </ul>

//       //           </div>

//       //       </div>
//       //       </Nav>

//       //   </nav>


// WEBPACK FOOTER //
// ./src/layout/Menu.js